<!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
<template>
  <b-button v-bind="$attrs"
            class="s-button"
            v-on="$listeners"
  >
    <sdui-icon v-if="icon"
               class="icon-14"
               :class="icon"
    />
    <slot />
  </b-button>
</template>

<script>
export default {
  name: 'SButton',
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.s-button.btn-alternate {
  background-color: transparent;

  &:hover {
    opacity: 0.5;
  }
}
</style>
